module.exports = __webpack_public_path__ + "img/quan.358cf7d5.png";